import { Link, useLocation } from "react-router-dom";

const NAV = [
  { label: "Services", href: "/services" },
  { label: "Groomers", href: "/groomers", flag: "showGroomers" },
  { label: "Reviews", href: "/reviews", flag: "showReviews" },
  { label: "Waiver", href: "/waiver" },
  { label: "Visit Us", href: "/visit" },
];

export default function Header({ settings }) {
  const { pathname } = useLocation();
  const nav = NAV.filter((n) => !n.flag || settings[n.flag] !== false);
  return (
    <header data-testid="site-header" className="sticky top-0 z-50 border-b border-lavender-700/10 bg-white/95 backdrop-blur-xl">
      <div className="relative mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-x-4 gap-y-2 px-5 py-3 sm:px-8 lg:py-4">
        <Link to="/" data-testid="header-logo-link" className="flex shrink-0 items-center">
          <img src="/assets/logo.png" alt="Pawtastic Cuts" data-testid="header-logo" className="h-14 w-auto sm:h-20 lg:h-24" />
        </Link>
        <nav aria-label="Main navigation" data-testid="header-nav" className="order-3 mt-2 flex w-full justify-center xl:absolute xl:left-1/2 xl:order-none xl:mt-0 xl:w-auto xl:-translate-x-1/2">
          <div className="flex flex-wrap items-center justify-center gap-1 rounded-3xl border border-lavender-700/10 bg-lavender-50 p-1.5 sm:rounded-full">
            {nav.map((n) => {
              const active = pathname === n.href;
              return (
                <Link key={n.href} to={n.href}
                  data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                  aria-current={active ? "page" : undefined}
                  className={`rounded-full px-3.5 py-2 text-xs font-semibold transition-colors duration-200 sm:px-4 sm:text-sm ${active ? "bg-lavender-700 text-white" : "text-stone-600 hover:text-lavender-700"}`}
                >{n.label}</Link>
              );
            })}
          </div>
        </nav>
        <div className="flex w-full items-center justify-center gap-2.5 sm:w-auto sm:gap-3.5">
          <div className="relative">
            <Link to="/groomiq" data-testid="header-groomiq-link" className="btn-indigo inline-flex min-h-11 items-center justify-center px-3.5 py-2.5 text-xs font-bold sm:px-4 sm:text-sm">
              <span className="tracking-wide">Learn About Your Dog</span>
            </Link>
            <span className="pointer-events-none absolute -right-2.5 -top-2.5 z-20 animate-newflash rounded-md bg-gradient-to-br from-rose-500 to-red-600 px-1.5 py-0.5 text-[10px] font-extrabold uppercase leading-none tracking-wider text-white shadow-[0_2px_8px_rgba(244,63,94,0.6)] ring-1 ring-white/50">New</span>
          </div>
          <Link to="/#book" data-testid="header-book-button" className="btn-primary inline-flex min-h-11 items-center justify-center px-4 py-2.5 text-sm font-bold sm:px-6">
            <span className="tracking-wide">Book Now</span>
          </Link>
        </div>
      </div>
    </header>
  );
}
